'use client';

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

import { Iconify } from 'src/components/iconify';

/**
 * 허브의 **즐겨찾기 별** — 목록의 별 칸과 상세 머리가 같은 별을 쓴다.
 *
 * 🔑 **별 하나다** — 빈 별(안 담음) · 채운 별(담음). 목록과 상세가 같은 모양이라야 같은 일로 읽힌다.
 * 🚨 **즐겨찾기는 표시일 뿐이다** — 수집은 돌지 않는다. 상세 머리는 그 말을 툴팁에 적는다(`hint`).
 * ⚠️ 툴팁은 `span` 으로 감싼다 — 꺼진 단추는 마우스 신호를 안 받아 툴팁이 안 뜬다.
 */
export function HubStarButton({
  saved,
  saving = false,
  disabled = false,
  onToggle,
  hint = '즐겨찾기',
}: {
  saved: boolean;
  /** 이 별을 지금 저장하는 중인가 — 별 자리에 도는 표시가 선다 */
  saving?: boolean;
  disabled?: boolean;
  onToggle: () => void;
  /** 안 담았을 때의 툴팁 — 담았으면 늘 「즐겨찾기에서 빼기」 */
  hint?: string;
}) {
  const label = saved ? '즐겨찾기에서 빼기' : '즐겨찾기';
  return (
    <Tooltip title={saved ? '즐겨찾기에서 빼기' : hint} placement="top" arrow>
      <Box component="span">
        <IconButton
          size="small"
          disabled={disabled}
          onClick={onToggle}
          aria-label={label}
          sx={{
            width: 28,
            height: 28,
            color: saved ? 'warning.main' : 'text.disabled',
            '&:hover': { color: saved ? 'warning.dark' : 'text.secondary' },
          }}
        >
          {saving ? (
            <CircularProgress size={13} />
          ) : (
            <Iconify icon={saved ? 'solar:star-bold' : 'solar:star-linear'} width={16} />
          )}
        </IconButton>
      </Box>
    </Tooltip>
  );
}
